import { History } from "lucide-react";
import React from "react";

export default function VoucherHeader({
  totalVouchers,
  availableVouchers,
  redeemedValue,
}) {
  return (
    <React.Fragment>
      <div className="page-header">
        <div>
          <h1 className="page-title">Voucher Management</h1>
          <p className="page-subtitle">Generate and manage game vouchers</p>
        </div>
        <div>
          <button className="export-btn">
            <History className="icon" />
            <span>Export History</span>
          </button>
        </div>
      </div>

      {/* Stats Cards */}
      <div className="stats-grid">
        <div className="card">
          <div className="card-header">
            <h2 className="card-title">Total Vouchers</h2>
          </div>
          <div className="card-content">
            <div className="stat-value total-vouchers">
              {totalVouchers ?? 0}
            </div>
            <p className="stat-label">Across all campaigns</p>
          </div>
        </div>

        <div className="card">
          <div className="card-header">
            <h2 className="card-title">Active Vouchers</h2>
          </div>
          <div className="card-content">
            <div className="stat-value active-vouchers">
              {availableVouchers ?? 0}
            </div>
            <p className="stat-label">Available for redemption</p>
          </div>
        </div>

        <div className="card">
          <div className="card-header">
            <h2 className="card-title">Redeemed Value</h2>
          </div>
          <div className="card-content">
            <div className="stat-value redeemed-value">
              {redeemedValue ?? 0}
            </div>
            <p className="stat-label">Total value redeemed</p>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
